import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Clock icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Clock } from '@sravni/design-system-icons'
 *
 * <Clock />
 * ```
 */
var Clock = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Clock", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m13.867 13.333-4.101-2.446V5.613", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Clock };
//# sourceMappingURL=Clock.js.map
